import { render } from "./SelectAdditionalInfoModal.vue?vue&type=template&id=159c296b"
import script from "./SelectAdditionalInfoModal.vue?vue&type=script&lang=js"
export * from "./SelectAdditionalInfoModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__